import {
  THIRD_PARTY_GPSLIVE_SAVE_CREDENTIALS,
  THIRD_PARTY_GPSLIVE_SAVE_CREDENTIALS_SUCCESS,
  THIRD_PARTY_GPSLIVE_SAVE_CREDENTIALS_FAILURE,
  THIRD_PARTY_GPSLIVE_CHECK_STATUS,
  THIRD_PARTY_GPSLIVE_CHECK_STATUS_SUCCESS,
  THIRD_PARTY_GPSLIVE_CHECK_STATUS_FAILURE,
  THIRD_PARTY_GPSLIVE_TEST_CONNECTION,
  THIRD_PARTY_GPSLIVE_TEST_CONNECTION_SUCCESS,
  THIRD_PARTY_GPSLIVE_TEST_CONNECTION_FAILURE,
  THIRD_PARTY_GPSLIVE_UNASSIGN,
  THIRD_PARTY_GPSLIVE_UNASSIGN_SUCCESS,
  THIRD_PARTY_GPSLIVE_UNASSIGN_FAILURE,
  THIRD_PARTY_VAPI_LIST,
  THIRD_PARTY_VAPI_LIST_SUCCESS,
  THIRD_PARTY_VAPI_LIST_FAILURE,
  THIRD_PARTY_VAPI_DATA,
  THIRD_PARTY_VAPI_DATA_SUCCESS,
  THIRD_PARTY_VAPI_DATA_FAILURE,
  THIRD_PARTY_VAPI_CREATE,
  THIRD_PARTY_VAPI_CREATE_SUCCESS,
  THIRD_PARTY_VAPI_CREATE_FAILURE,
  THIRD_PARTY_VAPI_UPDATE,
  THIRD_PARTY_VAPI_UPDATE_SUCCESS,
  THIRD_PARTY_VAPI_UPDATE_FAILURE,
  THIRD_PARTY_VAPI_DELETE,
  THIRD_PARTY_VAPI_DELETE_SUCCESS,
  THIRD_PARTY_VAPI_DELETE_FAILURE,
  THIRD_PARTY_VAPI_PROVISION,
  THIRD_PARTY_VAPI_PROVISION_SUCCESS,
  THIRD_PARTY_VAPI_PROVISION_FAILURE,
  THIRD_PARTY_VAPI_LINK_TWILIO,
  THIRD_PARTY_VAPI_LINK_TWILIO_SUCCESS,
  THIRD_PARTY_VAPI_LINK_TWILIO_FAILURE,
  THIRD_PARTY_VAPI_TOGGLE,
  THIRD_PARTY_VAPI_TOGGLE_SUCCESS,
  THIRD_PARTY_VAPI_TOGGLE_FAILURE,
  CALL_PROVIDER_LIST,
  CALL_PROVIDER_LIST_SUCCESS,
  CALL_PROVIDER_LIST_FAILURE,
  TELEPHONE_NUMBER_AVAILABLE,
  TELEPHONE_NUMBER_AVAILABLE_SUCCESS,
  TELEPHONE_NUMBER_AVAILABLE_FAILURE,
  TELEPHONE_NUMBER_PURCHASE,
  TELEPHONE_NUMBER_PURCHASE_SUCCESS,
  TELEPHONE_NUMBER_PURCHASE_FAILURE,
  TELEPHONE_NUMBER_LIST,
  TELEPHONE_NUMBER_LIST_SUCCESS,
  TELEPHONE_NUMBER_LIST_FAILURE,
  THIRD_PARTY_XERO_URL_AUTH,
  THIRD_PARTY_XERO_URL_AUTH_SUCCESS,
  THIRD_PARTY_XERO_URL_AUTH_FAILURE,
  THIRD_PARTY_XERO_CHECK_STATUS,
  THIRD_PARTY_XERO_CHECK_STATUS_SUCCESS,
  THIRD_PARTY_XERO_CHECK_STATUS_FAILURE,
  THIRD_PARTY_XERO_GENERATE_ACCESS_TOKEN,
  THIRD_PARTY_XERO_GENERATE_ACCESS_TOKEN_SUCCESS,
  THIRD_PARTY_XERO_GENERATE_ACCESS_TOKEN_FAILURE,
  THIRD_PARTY_XERO_ASSIGN_TENANT,
  THIRD_PARTY_XERO_ASSIGN_TENANT_SUCCESS,
  THIRD_PARTY_XERO_ASSIGN_TENANT_FAILURE,
  THIRD_PARTY_XERO_SYNC_MANUAL,
  THIRD_PARTY_XERO_SYNC_MANUAL_SUCCESS,
  THIRD_PARTY_XERO_SYNC_MANUAL_FAILURE,
  THIRD_PARTY_XERO_UNASSIGN_TENANT,
  THIRD_PARTY_XERO_UNASSIGN_TENANT_SUCCESS,
  THIRD_PARTY_XERO_UNASSIGN_TENANT_FAILURE,
  THIRD_PARTY_GOOGLE_URL_AUTH,
  THIRD_PARTY_GOOGLE_URL_AUTH_SUCCESS,
  THIRD_PARTY_GOOGLE_URL_AUTH_FAILURE,
  THIRD_PARTY_GOOGLE_GENERATE_ACCESS_TOKEN,
  THIRD_PARTY_GOOGLE_GENERATE_ACCESS_TOKEN_SUCCESS,
  THIRD_PARTY_GOOGLE_GENERATE_ACCESS_TOKEN_FAILURE,
  THIRD_PARTY_HMRC_URL_AUTH,
  THIRD_PARTY_HMRC_URL_AUTH_SUCCESS,
  THIRD_PARTY_HMRC_URL_AUTH_FAILURE,
  THIRD_PARTY_BRIGHTPAY_SAVE_CREDENTIALS,
  THIRD_PARTY_BRIGHTPAY_SAVE_CREDENTIALS_SUCCESS,
  THIRD_PARTY_BRIGHTPAY_SAVE_CREDENTIALS_FAILURE,
  THIRD_PARTY_BRIGHTPAY_URL_AUTH,
  THIRD_PARTY_BRIGHTPAY_URL_AUTH_SUCCESS,
  THIRD_PARTY_BRIGHTPAY_URL_AUTH_FAILURE,
  THIRD_PARTY_BRIGHTPAY_CHECK_STATUS,
  THIRD_PARTY_BRIGHTPAY_CHECK_STATUS_SUCCESS,
  THIRD_PARTY_BRIGHTPAY_CHECK_STATUS_FAILURE,
  THIRD_PARTY_BRIGHTPAY_GENERATE_ACCESS_TOKEN,
  THIRD_PARTY_BRIGHTPAY_GENERATE_ACCESS_TOKEN_SUCCESS,
  THIRD_PARTY_BRIGHTPAY_GENERATE_ACCESS_TOKEN_FAILURE,
  THIRD_PARTY_BRIGHTPAY_ASSIGN_EMPLOYER,
  THIRD_PARTY_BRIGHTPAY_ASSIGN_EMPLOYER_SUCCESS,
  THIRD_PARTY_BRIGHTPAY_ASSIGN_EMPLOYER_FAILURE,
  THIRD_PARTY_BRIGHTPAY_UNASSIGN,
  THIRD_PARTY_BRIGHTPAY_UNASSIGN_SUCCESS,
  THIRD_PARTY_BRIGHTPAY_UNASSIGN_FAILURE,
  THIRD_PARTY_BRIGHTPAY_SYNC_EMPLOYEES,
  THIRD_PARTY_BRIGHTPAY_SYNC_EMPLOYEES_SUCCESS,
  THIRD_PARTY_BRIGHTPAY_SYNC_EMPLOYEES_FAILURE,
  THIRD_PARTY_BRIGHTPAY_EMPLOYEE_LIST,
  THIRD_PARTY_BRIGHTPAY_EMPLOYEE_LIST_SUCCESS,
  THIRD_PARTY_BRIGHTPAY_EMPLOYEE_LIST_FAILURE,
} from "./actionType";

const initialData = {
  thirdPartyXeroUrlAuthData: [],
  thirdPartyXeroUrlAuthLoading: false,
  thirdPartyXeroUrlAuthDataFail: [],

  thirdPartyXeroCheckStatusData: [],
  thirdPartyXeroCheckStatusLoading: false,
  thirdPartyXeroCheckStatusDataFail: [],

  thirdPartyXeroGenerateAccessTokenData: [],
  thirdPartyXeroGenerateAccessTokenLoading: false,
  thirdPartyXeroGenerateAccessTokenDataFail: [],

  thirdPartyXeroAssignTenantData: [],
  thirdPartyXeroAssignTenantLoading: false,
  thirdPartyXeroAssignTenantDataFail: [],

  thirdPartyXeroSyncManualData: [],
  thirdPartyXeroSyncManualLoading: false,
  thirdPartyXeroSyncManualDataFail: [],

  thirdPartyXeroUnassignTenantData: [],
  thirdPartyXeroUnassignTenantLoading: false,
  thirdPartyXeroUnassignTenantDataFail: [],

  thirdPartyGoogleUrlAuthData: [],
  thirdPartyGoogleUrlAuthLoading: false,
  thirdPartyGoogleUrlAuthDataFail: [],

  thirdPartyGoogleGenerateAccessTokenData: [],
  thirdPartyGoogleGenerateAccessTokenLoading: false,
  thirdPartyGoogleGenerateAccessTokenDataFail: [],

  thirdPartyHmrcUrlAuthData: [],
  thirdPartyHmrcUrlAuthLoading: false,
  thirdPartyHmrcUrlAuthDataFail: [],

  thirdPartyBrightPaySaveCredentialsData: [],
  thirdPartyBrightPaySaveCredentialsLoading: false,
  thirdPartyBrightPaySaveCredentialsDataFail: [],

  thirdPartyBrightPayUrlAuthData: [],
  thirdPartyBrightPayUrlAuthLoading: false,
  thirdPartyBrightPayUrlAuthDataFail: [],

  thirdPartyBrightPayCheckStatusData: [],
  thirdPartyBrightPayCheckStatusLoading: false,
  thirdPartyBrightPayCheckStatusDataFail: [],

  thirdPartyBrightPayGenerateAccessTokenData: [],
  thirdPartyBrightPayGenerateAccessTokenLoading: false,
  thirdPartyBrightPayGenerateAccessTokenDataFail: [],

  thirdPartyBrightPayAssignEmployerData: [],
  thirdPartyBrightPayAssignEmployerLoading: false,
  thirdPartyBrightPayAssignEmployerDataFail: [],

  thirdPartyBrightPayUnassignData: [],
  thirdPartyBrightPayUnassignLoading: false,
  thirdPartyBrightPayUnassignDataFail: [],

  thirdPartyBrightPaySyncEmployeesData: [],
  thirdPartyBrightPaySyncEmployeesLoading: false,
  thirdPartyBrightPaySyncEmployeesDataFail: [],

  thirdPartyBrightPayEmployeeListData: [],
  thirdPartyBrightPayEmployeeListLoading: false,
  thirdPartyBrightPayEmployeeListDataFail: [],

  thirdPartyGpsLiveSaveCredentialsData: [],
  thirdPartyGpsLiveSaveCredentialsLoading: false,
  thirdPartyGpsLiveSaveCredentialsDataFail: [],

  thirdPartyGpsLiveCheckStatusData: [],
  thirdPartyGpsLiveCheckStatusLoading: false,
  thirdPartyGpsLiveCheckStatusDataFail: [],

  thirdPartyGpsLiveTestConnectionData: [],
  thirdPartyGpsLiveTestConnectionLoading: false,
  thirdPartyGpsLiveTestConnectionDataFail: [],

  thirdPartyGpsLiveUnassignData: [],
  thirdPartyGpsLiveUnassignLoading: false,
  thirdPartyGpsLiveUnassignDataFail: [],

  thirdPartyVapiListData: [],
  thirdPartyVapiListLoading: false,
  thirdPartyVapiListDataFail: [],

  thirdPartyVapiDataData: [],
  thirdPartyVapiDataLoading: false,
  thirdPartyVapiDataDataFail: [],

  thirdPartyVapiCreateData: [],
  thirdPartyVapiCreateLoading: false,
  thirdPartyVapiCreateDataFail: [],

  thirdPartyVapiUpdateData: [],
  thirdPartyVapiUpdateLoading: false,
  thirdPartyVapiUpdateDataFail: [],

  thirdPartyVapiDeleteData: [],
  thirdPartyVapiDeleteLoading: false,
  thirdPartyVapiDeleteDataFail: [],

  thirdPartyVapiProvisionData: [],
  thirdPartyVapiProvisionLoading: false,
  thirdPartyVapiProvisionDataFail: [],

  thirdPartyVapiLinkTwilioData: [],
  thirdPartyVapiLinkTwilioLoading: false,
  thirdPartyVapiLinkTwilioDataFail: [],

  thirdPartyVapiToggleData: [],
  thirdPartyVapiToggleLoading: false,
  thirdPartyVapiToggleDataFail: [],

  callProviderListData: [],
  callProviderListLoading: false,
  callProviderListDataFail: [],

  telephoneNumberAvailableData: [],
  telephoneNumberAvailableLoading: false,
  telephoneNumberAvailableDataFail: [],

  telephoneNumberPurchaseData: [],
  telephoneNumberPurchaseLoading: false,
  telephoneNumberPurchaseDataFail: [],

  telephoneNumberListData: [],
  telephoneNumberListLoading: false,
  telephoneNumberListDataFail: [],
};

const ThirdPartyIntegration = (state = initialData, { type, payload }) => {
  switch (type) {
    case THIRD_PARTY_XERO_URL_AUTH:
      return {
        ...state,
        thirdPartyXeroUrlAuthLoading: true,
      };
    case THIRD_PARTY_XERO_URL_AUTH_SUCCESS:
      return {
        ...state,
        thirdPartyXeroUrlAuthData: payload,
        thirdPartyXeroUrlAuthLoading: false,
      };
    case THIRD_PARTY_XERO_URL_AUTH_FAILURE:
      return {
        ...state,
        thirdPartyXeroUrlAuthDataFail: payload,
        thirdPartyXeroUrlAuthLoading: false,
      };
    case THIRD_PARTY_XERO_CHECK_STATUS:
      return {
        ...state,
        thirdPartyXeroCheckStatusLoading: true,
      };
    case THIRD_PARTY_XERO_CHECK_STATUS_SUCCESS:
      return {
        ...state,
        thirdPartyXeroCheckStatusData: payload,
        thirdPartyXeroCheckStatusLoading: false,
      };
    case THIRD_PARTY_XERO_CHECK_STATUS_FAILURE:
      return {
        ...state,
        thirdPartyXeroCheckStatusDataFail: payload,
        thirdPartyXeroCheckStatusLoading: false,
      };
    case THIRD_PARTY_XERO_GENERATE_ACCESS_TOKEN:
      return {
        ...state,
        thirdPartyXeroGenerateAccessTokenLoading: true,
      };
    case THIRD_PARTY_XERO_GENERATE_ACCESS_TOKEN_SUCCESS:
      return {
        ...state,
        thirdPartyXeroGenerateAccessTokenData: payload,
        thirdPartyXeroGenerateAccessTokenLoading: false,
      };
    case THIRD_PARTY_XERO_GENERATE_ACCESS_TOKEN_FAILURE:
      return {
        ...state,
        thirdPartyXeroGenerateAccessTokenDataFail: payload,
        thirdPartyXeroGenerateAccessTokenLoading: false,
      };
    case THIRD_PARTY_XERO_ASSIGN_TENANT:
      return {
        ...state,
        thirdPartyXeroAssignTenantLoading: true,
      };
    case THIRD_PARTY_XERO_ASSIGN_TENANT_SUCCESS:
      return {
        ...state,
        thirdPartyXeroAssignTenantData: payload,
        thirdPartyXeroAssignTenantLoading: false,
      };
    case THIRD_PARTY_XERO_ASSIGN_TENANT_FAILURE:
      return {
        ...state,
        thirdPartyXeroAssignTenantDataFail: payload,
        thirdPartyXeroAssignTenantLoading: false,
      };
    case THIRD_PARTY_XERO_SYNC_MANUAL:
      return {
        ...state,
        thirdPartyXeroSyncManualLoading: true,
      };
    case THIRD_PARTY_XERO_SYNC_MANUAL_SUCCESS:
      return {
        ...state,
        thirdPartyXeroSyncManualData: payload,
        thirdPartyXeroSyncManualLoading: false,
      };
    case THIRD_PARTY_XERO_SYNC_MANUAL_FAILURE:
      return {
        ...state,
        thirdPartyXeroSyncManualDataFail: payload,
        thirdPartyXeroSyncManualLoading: false,
      };
    case THIRD_PARTY_XERO_UNASSIGN_TENANT:
      return {
        ...state,
        thirdPartyXeroUnassignTenantLoading: true,
      };
    case THIRD_PARTY_XERO_UNASSIGN_TENANT_SUCCESS:
      return {
        ...state,
        thirdPartyXeroUnassignTenantData: payload,
        thirdPartyXeroUnassignTenantLoading: false,
      };
    case THIRD_PARTY_XERO_UNASSIGN_TENANT_FAILURE:
      return {
        ...state,
        thirdPartyXeroUnassignTenantDataFail: payload,
        thirdPartyXeroUnassignTenantLoading: false,
      };
    case THIRD_PARTY_GOOGLE_URL_AUTH:
      return {
        ...state,
        thirdPartyGoogleUrlAuthLoading: true,
      };
    case THIRD_PARTY_GOOGLE_URL_AUTH_SUCCESS:
      return {
        ...state,
        thirdPartyGoogleUrlAuthData: payload,
        thirdPartyGoogleUrlAuthLoading: false,
      };
    case THIRD_PARTY_GOOGLE_URL_AUTH_FAILURE:
      return {
        ...state,
        thirdPartyGoogleUrlAuthDataFail: payload,
        thirdPartyGoogleUrlAuthLoading: false,
      };
    case THIRD_PARTY_GOOGLE_GENERATE_ACCESS_TOKEN:
      return {
        ...state,
        thirdPartyGoogleGenerateAccessTokenLoading: true,
      };
    case THIRD_PARTY_GOOGLE_GENERATE_ACCESS_TOKEN_SUCCESS:
      return {
        ...state,
        thirdPartyGoogleGenerateAccessTokenData: payload,
        thirdPartyGoogleGenerateAccessTokenLoading: false,
      };
    case THIRD_PARTY_GOOGLE_GENERATE_ACCESS_TOKEN_FAILURE:
      return {
        ...state,
        thirdPartyGoogleGenerateAccessTokenDataFail: payload,
        thirdPartyGoogleGenerateAccessTokenLoading: false,
      };
    case THIRD_PARTY_HMRC_URL_AUTH:
      return {
        ...state,
        thirdPartyHmrcUrlAuthLoading: true,
      };
    case THIRD_PARTY_HMRC_URL_AUTH_SUCCESS:
      return {
        ...state,
        thirdPartyHmrcUrlAuthData: payload,
        thirdPartyHmrcUrlAuthLoading: false,
      };
    case THIRD_PARTY_HMRC_URL_AUTH_FAILURE:
      return {
        ...state,
        thirdPartyHmrcUrlAuthDataFail: payload,
        thirdPartyHmrcUrlAuthLoading: false,
      };

    case THIRD_PARTY_BRIGHTPAY_SAVE_CREDENTIALS:
      return { ...state, thirdPartyBrightPaySaveCredentialsLoading: true };
    case THIRD_PARTY_BRIGHTPAY_SAVE_CREDENTIALS_SUCCESS:
      return {
        ...state,
        thirdPartyBrightPaySaveCredentialsData: payload,
        thirdPartyBrightPaySaveCredentialsLoading: false,
      };
    case THIRD_PARTY_BRIGHTPAY_SAVE_CREDENTIALS_FAILURE:
      return {
        ...state,
        thirdPartyBrightPaySaveCredentialsDataFail: payload,
        thirdPartyBrightPaySaveCredentialsLoading: false,
      };

    case THIRD_PARTY_BRIGHTPAY_URL_AUTH:
      return { ...state, thirdPartyBrightPayUrlAuthLoading: true };
    case THIRD_PARTY_BRIGHTPAY_URL_AUTH_SUCCESS:
      return {
        ...state,
        thirdPartyBrightPayUrlAuthData: payload,
        thirdPartyBrightPayUrlAuthLoading: false,
      };
    case THIRD_PARTY_BRIGHTPAY_URL_AUTH_FAILURE:
      return {
        ...state,
        thirdPartyBrightPayUrlAuthDataFail: payload,
        thirdPartyBrightPayUrlAuthLoading: false,
      };

    case THIRD_PARTY_BRIGHTPAY_CHECK_STATUS:
      return { ...state, thirdPartyBrightPayCheckStatusLoading: true };
    case THIRD_PARTY_BRIGHTPAY_CHECK_STATUS_SUCCESS:
      return {
        ...state,
        thirdPartyBrightPayCheckStatusData: payload,
        thirdPartyBrightPayCheckStatusLoading: false,
      };
    case THIRD_PARTY_BRIGHTPAY_CHECK_STATUS_FAILURE:
      return {
        ...state,
        thirdPartyBrightPayCheckStatusDataFail: payload,
        thirdPartyBrightPayCheckStatusLoading: false,
      };

    case THIRD_PARTY_BRIGHTPAY_GENERATE_ACCESS_TOKEN:
      return { ...state, thirdPartyBrightPayGenerateAccessTokenLoading: true };
    case THIRD_PARTY_BRIGHTPAY_GENERATE_ACCESS_TOKEN_SUCCESS:
      return {
        ...state,
        thirdPartyBrightPayGenerateAccessTokenData: payload,
        thirdPartyBrightPayGenerateAccessTokenLoading: false,
      };
    case THIRD_PARTY_BRIGHTPAY_GENERATE_ACCESS_TOKEN_FAILURE:
      return {
        ...state,
        thirdPartyBrightPayGenerateAccessTokenDataFail: payload,
        thirdPartyBrightPayGenerateAccessTokenLoading: false,
      };

    case THIRD_PARTY_BRIGHTPAY_ASSIGN_EMPLOYER:
      return { ...state, thirdPartyBrightPayAssignEmployerLoading: true };
    case THIRD_PARTY_BRIGHTPAY_ASSIGN_EMPLOYER_SUCCESS:
      return {
        ...state,
        thirdPartyBrightPayAssignEmployerData: payload,
        thirdPartyBrightPayAssignEmployerLoading: false,
      };
    case THIRD_PARTY_BRIGHTPAY_ASSIGN_EMPLOYER_FAILURE:
      return {
        ...state,
        thirdPartyBrightPayAssignEmployerDataFail: payload,
        thirdPartyBrightPayAssignEmployerLoading: false,
      };

    case THIRD_PARTY_BRIGHTPAY_UNASSIGN:
      return { ...state, thirdPartyBrightPayUnassignLoading: true };
    case THIRD_PARTY_BRIGHTPAY_UNASSIGN_SUCCESS:
      return {
        ...state,
        thirdPartyBrightPayUnassignData: payload,
        thirdPartyBrightPayUnassignLoading: false,
      };
    case THIRD_PARTY_BRIGHTPAY_UNASSIGN_FAILURE:
      return {
        ...state,
        thirdPartyBrightPayUnassignDataFail: payload,
        thirdPartyBrightPayUnassignLoading: false,
      };

    case THIRD_PARTY_BRIGHTPAY_SYNC_EMPLOYEES:
      return { ...state, thirdPartyBrightPaySyncEmployeesLoading: true };
    case THIRD_PARTY_BRIGHTPAY_SYNC_EMPLOYEES_SUCCESS:
      return {
        ...state,
        thirdPartyBrightPaySyncEmployeesData: payload,
        thirdPartyBrightPaySyncEmployeesLoading: false,
      };
    case THIRD_PARTY_BRIGHTPAY_SYNC_EMPLOYEES_FAILURE:
      return {
        ...state,
        thirdPartyBrightPaySyncEmployeesDataFail: payload,
        thirdPartyBrightPaySyncEmployeesLoading: false,
      };

    case THIRD_PARTY_BRIGHTPAY_EMPLOYEE_LIST:
      return { ...state, thirdPartyBrightPayEmployeeListLoading: true };
    case THIRD_PARTY_BRIGHTPAY_EMPLOYEE_LIST_SUCCESS:
      return {
        ...state,
        thirdPartyBrightPayEmployeeListData: payload,
        thirdPartyBrightPayEmployeeListLoading: false,
      };
    case THIRD_PARTY_BRIGHTPAY_EMPLOYEE_LIST_FAILURE:
      return {
        ...state,
        thirdPartyBrightPayEmployeeListDataFail: payload,
        thirdPartyBrightPayEmployeeListLoading: false,
      };

    case THIRD_PARTY_GPSLIVE_SAVE_CREDENTIALS:
      return { ...state, thirdPartyGpsLiveSaveCredentialsLoading: true };
    case THIRD_PARTY_GPSLIVE_SAVE_CREDENTIALS_SUCCESS:
      return {
        ...state,
        thirdPartyGpsLiveSaveCredentialsData: payload,
        thirdPartyGpsLiveSaveCredentialsLoading: false,
      };
    case THIRD_PARTY_GPSLIVE_SAVE_CREDENTIALS_FAILURE:
      return {
        ...state,
        thirdPartyGpsLiveSaveCredentialsDataFail: payload,
        thirdPartyGpsLiveSaveCredentialsLoading: false,
      };

    case THIRD_PARTY_GPSLIVE_CHECK_STATUS:
      return { ...state, thirdPartyGpsLiveCheckStatusLoading: true };
    case THIRD_PARTY_GPSLIVE_CHECK_STATUS_SUCCESS:
      return {
        ...state,
        thirdPartyGpsLiveCheckStatusData: payload,
        thirdPartyGpsLiveCheckStatusLoading: false,
      };
    case THIRD_PARTY_GPSLIVE_CHECK_STATUS_FAILURE:
      return {
        ...state,
        thirdPartyGpsLiveCheckStatusDataFail: payload,
        thirdPartyGpsLiveCheckStatusLoading: false,
      };

    case THIRD_PARTY_GPSLIVE_TEST_CONNECTION:
      return { ...state, thirdPartyGpsLiveTestConnectionLoading: true };
    case THIRD_PARTY_GPSLIVE_TEST_CONNECTION_SUCCESS:
      return {
        ...state,
        thirdPartyGpsLiveTestConnectionData: payload,
        thirdPartyGpsLiveTestConnectionLoading: false,
      };
    case THIRD_PARTY_GPSLIVE_TEST_CONNECTION_FAILURE:
      return {
        ...state,
        thirdPartyGpsLiveTestConnectionDataFail: payload,
        thirdPartyGpsLiveTestConnectionLoading: false,
      };

    case THIRD_PARTY_GPSLIVE_UNASSIGN:
      return { ...state, thirdPartyGpsLiveUnassignLoading: true };
    case THIRD_PARTY_GPSLIVE_UNASSIGN_SUCCESS:
      return {
        ...state,
        thirdPartyGpsLiveUnassignData: payload,
        thirdPartyGpsLiveUnassignLoading: false,
      };
    case THIRD_PARTY_GPSLIVE_UNASSIGN_FAILURE:
      return {
        ...state,
        thirdPartyGpsLiveUnassignDataFail: payload,
        thirdPartyGpsLiveUnassignLoading: false,
      };

    case THIRD_PARTY_VAPI_LIST:
      return { ...state, thirdPartyVapiListLoading: true };
    case THIRD_PARTY_VAPI_LIST_SUCCESS:
      return {
        ...state,
        thirdPartyVapiListData: payload,
        thirdPartyVapiListLoading: false,
      };
    case THIRD_PARTY_VAPI_LIST_FAILURE:
      return {
        ...state,
        thirdPartyVapiListDataFail: payload,
        thirdPartyVapiListLoading: false,
      };

    case THIRD_PARTY_VAPI_DATA:
      return { ...state, thirdPartyVapiDataLoading: true };
    case THIRD_PARTY_VAPI_DATA_SUCCESS:
      return {
        ...state,
        thirdPartyVapiDataData: payload,
        thirdPartyVapiDataLoading: false,
      };
    case THIRD_PARTY_VAPI_DATA_FAILURE:
      return {
        ...state,
        thirdPartyVapiDataDataFail: payload,
        thirdPartyVapiDataLoading: false,
      };

    case THIRD_PARTY_VAPI_CREATE:
      return { ...state, thirdPartyVapiCreateLoading: true };
    case THIRD_PARTY_VAPI_CREATE_SUCCESS:
      return {
        ...state,
        thirdPartyVapiCreateData: payload,
        thirdPartyVapiCreateLoading: false,
      };
    case THIRD_PARTY_VAPI_CREATE_FAILURE:
      return {
        ...state,
        thirdPartyVapiCreateDataFail: payload,
        thirdPartyVapiCreateLoading: false,
      };

    case THIRD_PARTY_VAPI_UPDATE:
      return { ...state, thirdPartyVapiUpdateLoading: true };
    case THIRD_PARTY_VAPI_UPDATE_SUCCESS:
      return {
        ...state,
        thirdPartyVapiUpdateData: payload,
        thirdPartyVapiUpdateLoading: false,
      };
    case THIRD_PARTY_VAPI_UPDATE_FAILURE:
      return {
        ...state,
        thirdPartyVapiUpdateDataFail: payload,
        thirdPartyVapiUpdateLoading: false,
      };

    case THIRD_PARTY_VAPI_DELETE:
      return { ...state, thirdPartyVapiDeleteLoading: true };
    case THIRD_PARTY_VAPI_DELETE_SUCCESS:
      return {
        ...state,
        thirdPartyVapiDeleteData: payload,
        thirdPartyVapiDeleteLoading: false,
      };
    case THIRD_PARTY_VAPI_DELETE_FAILURE:
      return {
        ...state,
        thirdPartyVapiDeleteDataFail: payload,
        thirdPartyVapiDeleteLoading: false,
      };

    case THIRD_PARTY_VAPI_PROVISION:
      return { ...state, thirdPartyVapiProvisionLoading: true };
    case THIRD_PARTY_VAPI_PROVISION_SUCCESS:
      return {
        ...state,
        thirdPartyVapiProvisionData: payload,
        thirdPartyVapiProvisionLoading: false,
      };
    case THIRD_PARTY_VAPI_PROVISION_FAILURE:
      return {
        ...state,
        thirdPartyVapiProvisionDataFail: payload,
        thirdPartyVapiProvisionLoading: false,
      };

    case THIRD_PARTY_VAPI_LINK_TWILIO:
      return { ...state, thirdPartyVapiLinkTwilioLoading: true };
    case THIRD_PARTY_VAPI_LINK_TWILIO_SUCCESS:
      return {
        ...state,
        thirdPartyVapiLinkTwilioData: payload,
        thirdPartyVapiLinkTwilioLoading: false,
      };
    case THIRD_PARTY_VAPI_LINK_TWILIO_FAILURE:
      return {
        ...state,
        thirdPartyVapiLinkTwilioDataFail: payload,
        thirdPartyVapiLinkTwilioLoading: false,
      };

    case THIRD_PARTY_VAPI_TOGGLE:
      return { ...state, thirdPartyVapiToggleLoading: true };
    case THIRD_PARTY_VAPI_TOGGLE_SUCCESS:
      return {
        ...state,
        thirdPartyVapiToggleData: payload,
        thirdPartyVapiToggleLoading: false,
      };
    case THIRD_PARTY_VAPI_TOGGLE_FAILURE:
      return {
        ...state,
        thirdPartyVapiToggleDataFail: payload,
        thirdPartyVapiToggleLoading: false,
      };

    case CALL_PROVIDER_LIST:
      return { ...state, callProviderListLoading: true };
    case CALL_PROVIDER_LIST_SUCCESS:
      return {
        ...state,
        callProviderListData: payload,
        callProviderListLoading: false,
      };
    case CALL_PROVIDER_LIST_FAILURE:
      return {
        ...state,
        callProviderListDataFail: payload,
        callProviderListLoading: false,
      };

    case TELEPHONE_NUMBER_AVAILABLE:
      return { ...state, telephoneNumberAvailableLoading: true };
    case TELEPHONE_NUMBER_AVAILABLE_SUCCESS:
      return {
        ...state,
        telephoneNumberAvailableData: payload,
        telephoneNumberAvailableLoading: false,
      };
    case TELEPHONE_NUMBER_AVAILABLE_FAILURE:
      return {
        ...state,
        telephoneNumberAvailableDataFail: payload,
        telephoneNumberAvailableLoading: false,
      };

    case TELEPHONE_NUMBER_PURCHASE:
      return { ...state, telephoneNumberPurchaseLoading: true };
    case TELEPHONE_NUMBER_PURCHASE_SUCCESS:
      return {
        ...state,
        telephoneNumberPurchaseData: payload,
        telephoneNumberPurchaseLoading: false,
      };
    case TELEPHONE_NUMBER_PURCHASE_FAILURE:
      return {
        ...state,
        telephoneNumberPurchaseDataFail: payload,
        telephoneNumberPurchaseLoading: false,
      };

    case TELEPHONE_NUMBER_LIST:
      return { ...state, telephoneNumberListLoading: true };
    case TELEPHONE_NUMBER_LIST_SUCCESS:
      return {
        ...state,
        telephoneNumberListData: payload,
        telephoneNumberListLoading: false,
      };
    case TELEPHONE_NUMBER_LIST_FAILURE:
      return {
        ...state,
        telephoneNumberListDataFail: payload,
        telephoneNumberListLoading: false,
      };

    default:
      return state;
  }
};

export default ThirdPartyIntegration;
